import { getAllGeneralSettings } from "services/generalSettings.services";
import { useQuery  } from "react-query";

export const useGeneralSettings = () => {
  return useQuery("generalSettings", getAllGeneralSettings);
};
